// extracted by css-extract-rspack-plugin
export default {"icon":"icon-mTb7lV","success":"success-IFHRMo"};